/* unplugin-vue-components disabled */import { render, staticRenderFns } from "./smartGroupsDashboard.vue?vue&type=template&id=6a04262a&scoped=true&"
import script from "./smartGroupsDashboard.vue?vue&type=script&lang=js&"
export * from "./smartGroupsDashboard.vue?vue&type=script&lang=js&"
import style0 from "./smartGroupsDashboard.vue?vue&type=style&index=0&id=6a04262a&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6a04262a",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VCard } from 'vuetify/lib/components/VCard';
import { VChip } from 'vuetify/lib/components/VChip';
import { VChipGroup } from 'vuetify/lib/components/VChipGroup';
import { VCol } from 'vuetify/lib/components/VGrid';
import { VContainer } from 'vuetify/lib/components/VGrid';
import { VRow } from 'vuetify/lib/components/VGrid';
import { VSkeletonLoader } from 'vuetify/lib/components/VSkeletonLoader';
import { VSpacer } from 'vuetify/lib/components/VGrid';
installComponents(component, {VCard,VChip,VChipGroup,VCol,VContainer,VRow,VSkeletonLoader,VSpacer})
